import axios from "axios";

const BASE_URL = process.env.REACT_APP_PAYMENT_API_URL;
const GUEST_TOKEN = process.env.REACT_APP_USER_GUEST_TOKEN;

type PaymentGetOne = {
  _id: string;
};
export const paymentGatOne = async ({ _id }: PaymentGetOne) => {
  try {
    const url =
      BASE_URL + "/transaction/get-one/" + _id + "?p=businessId||paymentId";
    const res = await axios.get(url, {
      headers: {
        b: "67b4e295cac2201d41a87c3d",
        Authorization: `Bearer ${GUEST_TOKEN}`,
      },
    });
    return res.data;
  } catch (error: unknown) {
    console.log("Error paymentGatOne: ", error);
    throw error;
  }
};

type PaymentUpdateOne = {
  _id: string;
  payloadValue: { _id: string; value: string }[];
};
export const paymentUpdateOne = async ({
  _id,
  payloadValue,
}: PaymentUpdateOne) => {
  try {
    const url = BASE_URL + "/transaction/update-one";
    const res = await axios.put(
      url,
      {
        _id: _id,
        payloadValue: payloadValue,
      },
      {
        headers: {
          b: "67b4e295cac2201d41a87c3d",
          Authorization: `Bearer ${GUEST_TOKEN}`,
        },
      }
    );
    return res.data;
  } catch (error: unknown) {
    console.log("Error paymentGatOne: ", error);
    throw error;
  }
};
